import { get } from 'helpers/api';

export function loadInvalidFields() {
  return async (dispatch, getState) => {
    const { deal } = getState();
    const fields = await get(deal.invalidFieldsPath, { params: { dealType: deal.dealType, stage: deal.stage } });
    dispatch(setInvalidFields(fields));
  };
}

export const SET_INVALID_FIELDS = 'SET_INVALID_FIELDS';
export function setInvalidFields(fields) {
  return {
    type: SET_INVALID_FIELDS,
    fields,
  };
}